/* MY KITCHEN GADGETS — Cream & Oak interactions */
(function(){
'use strict';
var fmt=window.Shopify&&Shopify.formatMoney?function(c){return Shopify.formatMoney(c,window.theme&&theme.moneyFormat||'${{amount}}')}:function(c){return'$'+(c/100).toFixed(2);};

/* ─ SCROLL ANIMATIONS ─ */
function initAnimate(){
  if(!window.IntersectionObserver)return;
  var obs=new IntersectionObserver(function(e){e.forEach(function(x){if(x.isIntersecting){x.target.classList.add('is-visible');obs.unobserve(x.target);}});},{threshold:.08});
  document.querySelectorAll('[data-mk-animate]').forEach(function(el){obs.observe(el);});
}
function animateCards(){
  document.querySelectorAll('.grid-view-item').forEach(function(c,i){
    c.setAttribute('data-mk-animate','');
    c.setAttribute('data-delay',String(Math.min((i%4)+1,4)));
  });
}

/* ─ CART HELPERS ─ */
function getCart(cb){
  fetch('/cart.js',{headers:{'Accept':'application/json'}})
    .then(function(r){return r.json();})
    .then(function(c){cb(null,c);})
    .catch(function(e){cb(e);});
}
function addToCart(id,qty,cb){
  fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json','Accept':'application/json'},
    body:JSON.stringify({id:parseInt(id,10),quantity:qty||1})
  }).then(function(r){return r.json();})
    .then(function(d){if(d.status&&d.status!==200)throw new Error(d.description);cb(null,d);})
    .catch(function(e){cb(e);});
}

function updateCartBadge(count){
  document.querySelectorAll('[data-cart-count],.site-header__cart-count,.cart-link__bubble-num').forEach(function(el){
    el.textContent=count;
    el.style.display=count>0?'':'none';
  });
  var cartLink=document.querySelector('a.icon-btn[href="/cart"]');
  if(cartLink){
    var badge=cartLink.querySelector('.cart-count');
    if(!badge){badge=document.createElement('span');badge.className='cart-count';cartLink.appendChild(badge);}
    badge.textContent=count;
    badge.style.display=count>0?'':'none';
  }
}

function showToast(msg){
  var t=document.getElementById('mkh-toast');
  if(!t)return;
  t.textContent=msg;
  t.classList.add('is-visible');
  clearTimeout(t._tid);
  t._tid=setTimeout(function(){t.classList.remove('is-visible');},2800);
}

/* ─ QUICK-ADD (Debut .grid-view-item cards) ─ */
function initCardATC(){
  document.addEventListener('click',function(e){
    var btn=e.target.closest('.grid-view-item__atc-btn');
    if(!btn)return;
    e.preventDefault();
    var variantId=btn.dataset.variantId;
    if(!variantId){window.location.href=btn.dataset.url||'/cart';return;}
    var orig=btn.textContent;
    btn.textContent='Adding\u2026';
    btn.disabled=true;
    addToCart(variantId,1,function(err){
      if(err){btn.textContent=orig;btn.disabled=false;window.location.href='/cart';return;}
      btn.textContent='\u2713 Added!';
      getCart(function(err2,cart){
        if(!err2) updateCartBadge(cart.item_count);
      });
      showToast('\u2713 Added to cart');
      setTimeout(function(){btn.textContent=orig;btn.disabled=false;},2200);
    });
  });
}

/* ─ MKH CARD ATC (.mkh-product-card__atc) ─ */
function initMkhCardATC(){
  document.addEventListener('click',function(e){
    var btn=e.target.closest('.mkh-product-card__atc');
    if(!btn||btn.disabled)return;
    e.preventDefault();
    var variantId=btn.dataset.variantId;
    if(!variantId){window.location.href=btn.dataset.url||'/cart';return;}
    var origHTML=btn.innerHTML;
    btn.innerHTML='Adding\u2026';
    btn.disabled=true;
    addToCart(variantId,1,function(err){
      if(err){
        btn.innerHTML=origHTML;
        btn.disabled=false;
        showToast('Could not add to cart \u2014 please try again.');
        return;
      }
      btn.innerHTML='\u2713 Added!';
      getCart(function(err2,cart){
        if(!err2) updateCartBadge(cart.item_count);
      });
      showToast('\u2713 Added to cart');
      setTimeout(function(){btn.innerHTML=origHTML;btn.disabled=false;},2200);
    });
  });
}

/* ─ WISHLIST ─ */
var WL_KEY='mkg_wish';
function wlGet(){try{return JSON.parse(localStorage.getItem(WL_KEY)||'[]');}catch(e){return[];}}
function wlSave(list){
  try{localStorage.setItem(WL_KEY,JSON.stringify(list));}catch(e){}
  window.dispatchEvent(new CustomEvent('mkg:wishlist-changed'));
}
function wlHas(id){return wlGet().some(function(p){return String(p.id)===String(id);});}
function wlAdd(product){var list=wlGet();if(!wlHas(product.id))list.push(product);wlSave(list);}
function wlRemove(id){wlSave(wlGet().filter(function(p){return String(p.id)!==String(id);}));}
function wlUpdateButtons(){
  document.querySelectorAll('.mkh-product-card__wish[data-product-id]').forEach(function(btn){
    var id=btn.dataset.productId;
    var wishlisted=wlHas(id);
    btn.classList.toggle('is-wishlisted',wishlisted);
    btn.setAttribute('aria-pressed',wishlisted?'true':'false');
  });
}
function initWishlist(){
  wlUpdateButtons();
  document.addEventListener('click',function(e){
    var btn=e.target.closest('.mkh-product-card__wish[data-product-id]');
    if(!btn)return;
    e.preventDefault();
    var id=btn.dataset.productId;
    if(wlHas(id)){
      wlRemove(id);
      showToast('Removed from wishlist');
    } else {
      wlAdd({
        id:id,
        handle:btn.dataset.handle||'',
        title:btn.dataset.title||'',
        image:btn.dataset.image||'',
        price:btn.dataset.price||'',
        variantId:btn.dataset.variantId||'',
        url:btn.dataset.url||''
      });
      showToast('\u2665 Added to wishlist');
    }
    wlUpdateButtons();
  });
}

/* ─ STICKY ATC (product page) ─ */
function initStickyATC(){
  var originalBtn=document.querySelector('[id^="AddToCart-"]');
  if(!originalBtn)return;
  var titleEl=document.querySelector('.product-single__title');
  var priceEl=document.querySelector('[id^="ProductPrice-"]');
  var bar=document.createElement('div');
  bar.className='mkitchen-sticky-atc';
  bar.innerHTML='<div class="mkitchen-sticky-atc__inner">'+
    '<span class="mkitchen-sticky-atc__title">'+(titleEl?titleEl.textContent.trim():'')+'</span>'+
    '<span class="mkitchen-sticky-atc__price" id="mkStickyPrice">'+(priceEl?priceEl.textContent.trim():'')+'</span>'+
    '<button class="mkitchen-sticky-atc__btn" type="button" id="mkStickyBtn">Add to cart</button>'+
  '</div>';
  document.body.appendChild(bar);
  var stickyBtn=bar.querySelector('#mkStickyBtn');
  var stickyPrice=bar.querySelector('#mkStickyPrice');
  if(window.IntersectionObserver){
    new IntersectionObserver(function(e){
      bar.classList.toggle('is-visible',!e[0].isIntersecting);
    },{threshold:.5}).observe(originalBtn);
  }
  if(priceEl){
    new MutationObserver(function(){
      if(stickyPrice)stickyPrice.textContent=priceEl.textContent.trim();
      stickyBtn.disabled=originalBtn.disabled;
      stickyBtn.textContent=originalBtn.disabled?'Sold out':'Add to cart';
    }).observe(priceEl,{childList:true,characterData:true,subtree:true});
  }
  stickyBtn.addEventListener('click',function(){
    if(!originalBtn.disabled){
      originalBtn.click();
      stickyBtn.textContent='\u2713 Added!';
      setTimeout(function(){stickyBtn.textContent='Add to cart';},2000);
    }
  });
}

/* ─ DISPATCH COUNTDOWN (PDP urgency card) ─ */
function initCountdown(){
  var el=document.getElementById('mkCountdown');
  if(!el)return;
  var end=parseInt(el.dataset.seconds||1800,10);
  var t=setInterval(function(){
    end--;
    if(end<=0){clearInterval(t);el.textContent='00:00:00';return;}
    var h=Math.floor(end/3600),m=Math.floor((end%3600)/60),s=end%60;
    el.textContent=(h>0?pad(h)+':':'')+pad(m)+':'+pad(s);
  },1000);
  function pad(n){return n<10?'0'+n:String(n);}
}

/* ─ INIT ─ */
function init(){
  animateCards();
  initAnimate();
  initCardATC();
  initMkhCardATC();
  initWishlist();
  if(document.querySelector('.product-template__container'))initStickyATC();
  initCountdown();
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();
